import { createApp } from 'vue';
import cmpBundlesSearch from '../vue/BundlesSearch.vue';

window.BundlesSearch = (function(){
	const component = createApp(cmpBundlesSearch, {
		bundleSearchModel: window.bundleSearchModel
	});
	delete window.bundleSearchModel;
	return component.mount('#component-bundles-search');
})();